
























import Vue from 'vue'
import dayjs from 'dayjs'
import FullModalLayout from '@/components/modal/basics/FullModal/FullModalLayout.vue'
import FullModalHeaderCloseButton from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderCloseButton.vue'
import FullModalHeaderTitle from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderTitle.vue'
import SelectButton from '@/components/modal/basics/SelectButton.vue'
import CalendarPicker from './basics/CalendarPicker.vue'

export default Vue.extend({
  components: {
    FullModalLayout,
    FullModalHeaderCloseButton,
    FullModalHeaderTitle,
    CalendarPicker,
    SelectButton,
  },
  props: {
    name: {
      type: String as () => string,
      default: 'DateModal',
    },
    values: {
      type: Array as () => string[],
      required: true,
    },
  } as const,
  data() {
    return {
      dates: [] as string[],
    }
  },
  computed: {
    isValid(): boolean {
      return this.dates.length !== 0
    },
  },
  methods: {
    onSubmit(): void {
      this.$emit('submit', this.dates)
      this.$modal.pop()
    },
    beforeOpen(): void {
      // カレンダーの状態を入力状態から初期化・セットする
      this.dates = this.values
        .map((date) => {
          const d = dayjs(date)
          return d.isValid() ? d.format('YYYY-MM-DD') : null
        })
        // 無効な日付は除外する
        .filter((d) => d) as string[]
    },
    beforeClose(): void {
      // カレンダーを閉じる前に内部の値は全て初期化しておく
      this.dates = []
    },
    onDatesChange(dates: string[]) {
      this.dates = dates.map((d) => dayjs(d).format('YYYY-MM-DD'))
    },
  },
})
